export enum AlertType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export interface UWAlert {
  startDate: string,
  endDate: string,
  type: AlertType,
  title: string,
  message: string
}
